import apiClient from './apiClient';
import { LOGIN_AUTHENTICATION_URL } from './apiUrl';

const getLoginAuthenticationApi = data => {
  return apiClient.post(LOGIN_AUTHENTICATION_URL, data);
};

export default getLoginAuthenticationApi;
